import { ReactComponent as AllChaDa } from "../assets/giwaPattern/all_cha_da.svg";
import { ReactComponent as Charong } from "../assets/giwaPattern/charong.svg";
import { ReactComponent as Doran } from "../assets/giwaPattern/doran.svg";
import { ReactComponent as Pass } from "../assets/giwaPattern/pass.svg";
import { ReactComponent as ItHing } from "../assets/giwaPattern/it_hing.svg";
import { ReactComponent as Jackpot } from "../assets/giwaPattern/jackpot.svg";
import { ReactComponent as Love } from "../assets/giwaPattern/love.svg";
import { ReactComponent as PeepBo } from "../assets/giwaPattern/peep_bo.svg";
import { ReactComponent as Poop } from "../assets/giwaPattern/poop.svg";
import { ReactComponent as Respect } from "../assets/giwaPattern/respect.svg";
import { ReactComponent as Schurm } from "../assets/giwaPattern/schurm.svg";
import { ReactComponent as Thanks } from "../assets/giwaPattern/thanks.svg";
import AllChaDaPath from "../assets/giwaPattern/all_cha_da.png";
import CharongPath from "../assets/giwaPattern/charong.png";
import DoranPath from "../assets/giwaPattern/doran.png";
import ItHingPath from "../assets/giwaPattern/it_hing.png";
import JackpotPath from "../assets/giwaPattern/jackpot.png";
import LovePath from "../assets/giwaPattern/love.png";
import PassPath from "../assets/giwaPattern/pass.png";
import PeepBoPath from "../assets/giwaPattern/peep_bo.png";
import PoopPath from "../assets/giwaPattern/poop.png";
import RespectPath from "../assets/giwaPattern/respect.png";
import SchurmPath from "../assets/giwaPattern/schurm.png";
import ThanksPath from "../assets/giwaPattern/thanks.png";

export default [
  {
    id: 1,
    name: "1번째 기와",
    data: "M112.64,98.09c0,0,15.54,19.88,24.89,24.14c0,0,23.66,11.53,40.33,9.75l45.22-61.33c0,0-2.56-1.11-4-0.78l-62.44-31.89L112.64,98.09z",
    svg: <Thanks />,
    imgUrl: ThanksPath,
  },
  {
    id: 2,
    name: "2번째 기와",
    data: "M223.08,70.64c0,0,2.33,1.56,2.44,2.56l69.89,35.67c0,0,3.11-0.33,4.56,0.67l-43.78,65.78c0,0-2.11-2.11-5.22,0c0,0-20.78,5.56-44.22-7.78c0,0-22.56-13.33-26-31.78c0,0-0.89-3.11-2.89-3.78L223.08,70.64z",
    svg: <PeepBo />,
    imgUrl: PeepBoPath,
  },
  {
    id: 3,
    name: "3번째 기와",
    data: "M299.97,109.2c0,0,3.11,2.33,3,3.11l70.44,35.67l-44.44,70.44c0,0-35.78-2.11-47.33-10.11c0,0-20.78-13.44-24.67-28.33l-0.78-4.67L299.97,109.2z",
    svg: <Jackpot />,
    imgUrl: JackpotPath,
  },
  {
    id: 4,
    name: "4번째 기와",
    data: "M373.41,147.98l68.38,35.91l-41.19,77.19c0,0-19.26,4.74-40.89-8c0,0-16.44-8.74-30.75-34.65L373.41,147.98z",
    svg: <Doran />,
    imgUrl: DoranPath,
  },
  {
    id: 5,
    name: "5번째 기와",
    data: "M61.84,165.85c0,0,10.87,16.63,26.83,21.77c0,0,18.11,10.33,33.26,10.29c0,0,6-0.41,5.91,1.99l49.46-67.59c0,0-28.67-1.11-44-12.89c0,0-21.11-16.89-20.67-21.33L61.84,165.85z",
    svg: <Poop />,
    imgUrl: PoopPath,
  },
  {
    id: 6,
    name: "6번째 기와",
    data: "M128.66,198.78c0,0,2.62,2.15,2.62,5.26c0,0,10.67,17.33,26.22,26.96c0,0,26.81,17.04,45.33,17.78c0,0,1.63-1.33,3.41,0l49.95-73.47c0,0-0.27-2.45-6.74,0.33c0,0-25.4,4.12-44.01-8.92c0,0-20.29-13.03-24.41-29.63	c0,0-0.76-5.26-3.18-5.1L128.66,198.78z",
    svg: <Love />,
    imgUrl: LovePath,
  },
  {
    id: 7,
    name: "7번째 기와",
    data: "M206.24,248.78c0,0,2.67,2.37,2.37,4.3c0,0,14.37,22.37,26.81,27.7c0,0,17.04,12.59,42.22,11.7c0,0,2.67-1.24,5.04,0.04l46.81-74.11c0,0-37.93-3.19-46.15-9.06c0,0-25.65-14.18-27.16-34.05",
    svg: <Schurm />,
    imgUrl: SchurmPath,
  },
  {
    id: 8,
    name: "8번째 기와",
    data: "M282.69,292.53c0,0,3.04,2.47,2.81,4.25c0,0,13.78,21.33,31.78,28.67c0,0,29.33,13.56,41.33,13.11l42-77.48c0,0-22.3,4.52-43.72-9.8c0,0-13.76-7.46-27.92-33.24L282.69,292.53z",
    svg: <AllChaDa />,
    imgUrl: AllChaDaPath,
  },
  {
    id: 9,
    name: "9번째 기와",
    data: "M5.73,188.18l56.11-22.33c0,0,4.17,11.78,24.46,20.72c14.8,6.52,18.76,9.28,37.76,11.62c0,0,3.11,0.39,3.78,1.72l-53.89,39.28c0,0-1.22-2.22-1.11-4.67c0,0-22.81,0.37-44.67-15.89C28.17,218.62,8.73,202.96,5.73,188.18z",
    svg: <ItHing />,
    imgUrl: ItHingPath,
  },
  {
    id: 10,
    name: "10번째 기와",
    data: "M73.95,239.18l54.71-40.4c0,0,2.95,2.63,2.62,5.26c0,0,15.12,23.14,29.5,28.94c0,0,26.72,14.69,40.72,15.8c0,0,3.18-1.8,4.74,0c1.56,1.8,0,0.44,0,0.44l-44.52,51c0,0-1.78-0.56-1.22-4.67c0,0-36.44-2.33-52.56-15.33	c0,0-21.11-16.67-27.56-38.44C80.39,241.78,77.16,243.91,73.95,239.18z",
    svg: <Respect />,
    imgUrl: RespectPath,
  },
  {
    id: 11,
    name: "11번째 기와",
    data: "M206.24,249.22c0,0,2.48,0.37,2.37,3.85c0,0,14.29,22.22,27.42,28.13c0,0,22.54,14.21,41.61,11.28	c0,0,3.71-1.23,5.04,0.04l-24.74,65.36c0,0-3.33,0.56-3-4.44c0,0-38.33-2.42-52.44-14.88c0,0-30.78-16.57-35.89-38.34	c0,0-2.95,0.81-4.33,0L206.24,249.22z",
    svg: <Charong />,
    imgUrl: CharongPath,
  },
  {
    id: 12,
    name: "12번째 기와",
    data: "M257.95,357.89c0,0,1.63,0.96,4,0c0,0,13.93,27.19,40.15,35.48c0,0,32.59,12.15,54.96,9.19c0,0,0.74-4,1.33-5.33V339.5c0,0-28.89-7.39-44.27-15.51c0,0-13.84-5.33-28.61-27.22c0,0-1.63-3.73-2.81-4.25l-24.74,66.03",
    svg: <Pass />,
    imgUrl: PassPath,
  },
];
